import { render, staticRenderFns } from "./v_Admin_Blogs.vue?vue&type=template&id=13514c6f&scoped=true&"
import script from "./v_Admin_Blogs.vue?vue&type=script&lang=js&"
export * from "./v_Admin_Blogs.vue?vue&type=script&lang=js&"
import style0 from "./v_Admin_Blogs.vue?vue&type=style&index=0&id=13514c6f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13514c6f",
  null
  
)

export default component.exports